import { MouseEvent } from 'react';

export interface IAnchorButtonProps {
    onClick?: React.MouseEventHandler<HTMLAnchorElement>;
    href?: string;
    'data-type'?: string;
    newWindow?: boolean;
    noDecoration?: boolean;
    children: React.ReactNode;
}

export const AnchorButton: React.FC<IAnchorButtonProps> = ({ onClick, href, children, 'data-type': dataType, newWindow, noDecoration }) => {
    if (!href && !onClick) {
        throw new Error('Either href or onClick is required');
    }

    const handleClick = (e: MouseEvent<HTMLAnchorElement>) => {
        e.stopPropagation();

        if (!href) {
            e.preventDefault();
        }

        if (onClick) {
            onClick(e);
        }
    };

    return (
        <a
            data-type={dataType}
            href={href}
            onClick={handleClick}
            target={newWindow ? '_blank' : undefined}
            style={{cursor: 'pointer', textDecoration: noDecoration ? 'none' : 'underline'}}
        >
            {children}
        </a>
    );
};
